module.exports = __webpack_public_path__ + "a86ae8598d0dc384b34a24fbf2157f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/huaxia_c.png
// module id = 292
// module chunks = 3